<div class="confirmWrapper">
    <div class="msgBox text-center">
        {{message|translate}}
    </div>
    <div class="button_outer">
        <div class="row justify-content-center">
            <div class="col-auto">
                <button class="bx-btn bx-btn-primary" (click)="closePopup(true)" >{{buttonText | translate}}</button>
            </div>
            <div class="col-auto">
                <button class="bx-btn bx-btn-danger" (click)="closePopup(false)"  *ngIf="cancleShow">{{cancelText | translate}}</button>
            </div>
        </div>
    </div>
</div>
